"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapResults = void 0;
const models_1 = require("../models");
const unwrapResults = (results) => {
    return results.reduce((acc, currentResult) => {
        if ((0, models_1.isOkResult)(currentResult)) {
            return {
                ...acc,
                data: [...acc.data, currentResult.data],
            };
        }
        return {
            ...acc,
            errorItems: [...acc.errorItems, currentResult],
        };
    }, {
        data: [],
        errorItems: [],
    });
};
exports.unwrapResults = unwrapResults;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0LnV0aWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvcmVzdWx0LnV0aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBSUEsc0NBQXNDO0FBRS9CLE1BQU0sYUFBYSxHQUFHLENBQUksT0FBd0IsRUFBNEMsRUFBRTtJQUNyRyxPQUFPLE9BQU8sQ0FBQyxNQUFNLENBQ25CLENBQUMsR0FBRyxFQUFFLGFBQWEsRUFBRSxFQUFFO1FBQ3JCLElBQUksSUFBQSxtQkFBVSxFQUFDLGFBQWEsQ0FBQyxFQUFFO1lBQzdCLE9BQU87Z0JBQ0wsR0FBRyxHQUFHO2dCQUNOLElBQUksRUFBRSxDQUFDLEdBQUcsR0FBRyxDQUFDLElBQUksRUFBRSxhQUFhLENBQUMsSUFBSSxDQUFDO2FBQ3hDLENBQUE7U0FDRjtRQUVELE9BQU87WUFDTCxHQUFHLEdBQUc7WUFDTixVQUFVLEVBQUUsQ0FBQyxHQUFHLEdBQUcsQ0FBQyxVQUFVLEVBQUUsYUFBYSxDQUFDO1NBQy9DLENBQUE7SUFDSCxDQUFDLEVBQUU7UUFDRCxJQUFJLEVBQUUsRUFBRTtRQUNSLFVBQVUsRUFBRSxFQUFFO0tBQ2YsQ0FDRixDQUFBO0FBQ0gsQ0FBQyxDQUFBO0FBbkJZLFFBQUEsYUFBYSxpQkFtQnpCIn0=